import React from 'react';
import { Edit2 } from 'lucide-react';

const EditableHeader = ({ displayName }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Edit2
        size={14}
        strokeWidth={2.25}
        color="#2f80ed"
        style={{ flexShrink: 0, marginRight: 6 }}
        aria-hidden="true"
      />

      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {displayName}
      </span>
    </div>
  );
};

export default EditableHeader;
